import { useLanguage } from '@stores/language.store.js';
import { usePrinterSummationData } from '@stores/printerSummation.store';
import { useUser } from '@stores/user.store.js';
import { useUserTicketsSummationData } from '@stores/userTicketsSummation.store';
import { useUserSurveyData } from '@stores/useSurveyStore.js';

export function usePrinterSummationPage() {
  const {
    isTicketsLoading,
    ticketsError,
    getTickets,
    tickets,
    ticketsCount,
    totalSum,
    isSurveyDone,
  } = useUserTicketsSummationData();

  const { user, userError, isUserLoading } = useUser();

  const { langError, isLangLoading } = useLanguage();

  const { isSurveyLoading, surveyError, surveyResult } = useUserSurveyData();

  const { isPrinterLoading, sendToPrinter, printerError } =
    usePrinterSummationData();

  const showPreloader = [
    isUserLoading,
    isTicketsLoading,
    isLangLoading,
    isSurveyLoading,
    isPrinterLoading,
  ].some(Boolean);

  const isError = [
    ticketsError,
    userError,
    langError,
    surveyError,
    printerError,
  ].some(Boolean);

  return {
    isTicketsLoading,
    ticketsError,
    getTickets,
    tickets,
    ticketsCount,
    totalSum,
    isSurveyDone,
    user,
    isUserLoading,
    isLangLoading,
    isSurveyLoading,
    surveyResult,
    sendToPrinter,
    showPreloader,
    isError,
  };
}
